<template>
<div>
  <div :class="['liveroom', 'room-'+room]">
    <!-- <img src="../assets/liveroom.jpg" /> -->
    <div class="inner">

    </div>
  </div>
  <div class=" black selector">
    <div class="inner">
          <div class="rooms">
        <div :class="['room', room==0?'selected':'']" @click="room=0">
          <h1>The Live Room</h1>
          
        </div>
        <div :class="['room', room==1?'selected':'']" @click="room=1">
          <h1>Control Room A</h1>
          
        </div>
        <div :class="['room', room==2?'selected':'']" @click="room=2">
          <h1>Control Room B</h1>
          

        </div>
      </div>
    </div>
  </div>

  <div class="page light content">

    <div class="inner">
    <!-- ////////////// -->
    <div v-if="room == 0">
      <!-- <h1>The Live Room</h1> -->
      <img src="../assets/drumkit.jpg" />
      <!-- <img src="../assets/piano.jpg" /> -->
      <p>Spacious live room between two control rooms.  Contains a PA, Piano, Organ, GIK Acoustic Panels, Aurelex Hover Deck and Hover Mat (for improved drum sound) and space for a full band.</p>
    </div>

    <!-- ///////////// -->
    <div v-if="room == 1">
      <!-- <h1>Control Room A</h1> -->
      <img src="../assets/controlroom2.jpg" />
      <p>The main control room has been carefully designed to create the perfect listening environment.  </p>
      <p>The room is acoustically isolated from the rest of the building and the floor is suspended on 
        Auralex U-Boats creating a giant bass trap.  The acoustic floating floor in conjunction with the corner, 
        ceiling and wall acoustic treatment ensures that your projects will be tracked, mixed and mastered in the 
        ideal environment.</p>
    </div>

    <!-- ///////////// -->
    <div v-if="room == 2">
      <!-- <h1>Control Room B</h1> -->
      <img src="../assets/gibson_sm.jpg" />
      <p>Sessions can now be booked utilising an alternative control room, equipment set and engineer during off-peak hours at a reduced rate.  Ideal for new bands, demos and pre-production.  Please contact us for more info.  Limited Availability.</p>
      <p>This room may also double as an isolation room on larger sessions booked in the main control room.</p>
    </div>
    <div style="clear: both"></div>
    <!-- //////////// -->
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'LiveRoom',
  data: function(){
    return {
      room: 0
    }
  }
}
</script>

<style scoped lang="scss">
$yellow: rgb(250, 231, 169);
.selector{
  min-height: auto;
  height: auto;
  max-height: auto;
  padding:0;
  position: sticky;
  top:73px;
  background-image: url('../assets/bgblack.png')
}
.inner{
  max-width: 1200px;
  margin: 0 auto;
}
.rooms{
  display:flex;
}
.room{
  flex:1 1 33%;
  border: 1px solid rgba(255,255,255,0.2);
  cursor: pointer;
  background-color:rgba(0,0,0,0.4);

  padding:0.25em 1em;
  &:hover{
    background-color:rgba(0,0,0,0.6);
  }
  @media only screen and (max-width: 600px) {
    h1{
      font-size: large;
    }
    font-size: small;
  }
}
.selected{
  // background-color:rgba(255,255,255,0.6);
  background: url('../assets/bgwhite.png');
  border-bottom: none;
  color: black;
  &:hover{
    background-color:rgba(255,255,255,0.8);
  }
  h1{
    color:rgb(109, 27, 26);
  }
}

.liveroom{
  
  height: 70vh;
  color:white;

  background-size: cover;
  background-position: center; 
  display: flex;
  align-items: flex-end;
  justify-content: center;
  .inner{
    max-width: 1200px;
    width:1200px;
    padding:2em;
  }
  @media only screen and (max-width: 600px) {
      height: 55vh;
   }

}
.liveroom img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    box-sizing: border-box;
    

}
.room-0{
    background-image: url('../assets/liveroom.jpg');
}
.room-1{
    background-image: url('../assets/controlroom.jpg');
}
.room-2{
    background-image: url('../assets/studiob2.jpg');
    
}

.content{
  min-height: 25vh;
  img{
    border-radius: 20px;
    border: 2px solid silver;
    // max-width:300px;
    max-width: calc(50vw - 4em);
    max-height:150px;
    float: right;
  }
}
h1{
  color: $yellow;
}



</style>
